import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Admin from "@/pages/Admin";
import Recovery from "@/pages/Recovery";
import RecoveryPay from "@/pages/RecoveryPay";
import PaymentReturn from "@/pages/PaymentReturn";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/recovery" element={<Recovery />} />
        <Route path="/recovery/pay/:token" element={<RecoveryPay />} />
        <Route path="/payment-return" element={<PaymentReturn />} />
      </Routes>
    </BrowserRouter>
  );
}
